import { SET_COLLABORATORS } from "../actionTypes";

const INIT_STATE = {
  data: [],
  total: 0,
};

const Collaborators = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_COLLABORATORS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default Collaborators;
